import { jsx } from 'react/jsx-runtime';
import { enUS, zhTW, zhCN, sl, sv, ru, pt, ptBR, pl, ko, ja, it, he, enGB, fr, frCA, es, de, cs, bg } from 'date-fns/locale';
import { createContext, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_LOCALE = enUS;
/**
 * The supported languages in Optibus.
 */
const OPTIBUS_LANGUAGES = [
    'bg',
    'cn',
    'cz',
    'de',
    'en',
    'es',
    'es-419',
    'es-latam',
    'fr',
    'fr-ca',
    'gb',
    'gb-restdays',
    'he',
    'it',
    'ja',
    'kr',
    'pl',
    'pt',
    'pt-portugal',
    'ru',
    'se',
    'sl',
    'zh-cn',
    'zh-tw',
];
/**
 * Locale is for date-fns format.
 * valid locales can be seen at https://github.com/date-fns/date-fns/tree/main/src/locale
 */
const languageToLocale = (language) => {
    if (typeof language !== 'string')
        return language;
    const [major, minor] = language.split('-');
    switch (major) {
        case 'bg':
            return bg;
        case 'cn':
            return zhTW;
        case 'cz':
            return cs;
        case 'de':
            return de;
        case 'en':
            return enUS;
        case 'es':
            return es;
        case 'fr':
            switch (minor) {
                case 'ca':
                    return frCA;
                default:
                    return fr;
            }
        case 'gb':
            return enGB;
        case 'he':
            return he;
        case 'it':
            return it;
        case 'ja':
            return ja;
        case 'kr':
            return ko;
        case 'pl':
            return pl;
        case 'pt':
            switch (minor) {
                case 'portugal':
                    return ptBR;
                default:
                    return pt;
            }
        case 'ru':
            return ru;
        case 'se':
            return sv;
        case 'sl':
            return sl;
        case 'zh':
            switch (minor) {
                case 'cn':
                    return zhCN;
                case 'tw':
                default:
                    return zhTW;
            }
    }
};
const LocaleContext = createContext(DEFAULT_LOCALE);
const LocaleFromLanguageProvider = (props) => {
    const languageLocale = languageToLocale(props.language);
    useEffect(() => {
        if (!languageLocale) {
            console.error(`Language '${props.language}' does not have a locale.`);
        }
    }, [props.language, languageLocale]);
    const locale = languageLocale !== null && languageLocale !== void 0 ? languageLocale : DEFAULT_LOCALE;
    return jsx(LocaleContext.Provider, Object.assign({ value: locale }, { children: props.children }));
};
const LocaleProvider = (props) => {
    const { i18n } = useTranslation();
    const { language } = i18n;
    return jsx(LocaleFromLanguageProvider, Object.assign({ language: language }, { children: props.children }));
};
const useLocale = () => useContext(LocaleContext);

export { LocaleFromLanguageProvider, LocaleProvider, OPTIBUS_LANGUAGES, languageToLocale, useLocale };
//# sourceMappingURL=locale.js.map
